import { ThunkDispatch, Action } from 'store/store';
import Services from 'store/Services';
import State from 'store/State';
import { buildLoggerForStore, logForStore } from 'logging/writers/utils';
import { LogLevel } from '@instinet-analytics/core-lib';
import LayoutService from 'layout/LayoutService';

/* eslint-disable @typescript-eslint/no-explicit-any */

const composeFetchAction =
    <ServiceCall extends keyof LayoutService, Payload extends any[]>(
        serviceCall: ServiceCall
    ) =>
    (handler: (error: any, result: any) => void, ...payload: Payload) =>
    async (
        dispatch: ThunkDispatch<Action<unknown>>,
        getState: () => State,
        { layoutService, loggingService }: Services
    ) => {
        const log = buildLoggerForStore('layoutManagement');

        try {
            log(loggingService, serviceCall, { payload });
            const result = await (layoutService[serviceCall] as any)(
                ...payload
            );
            handler(null, result);
        } catch (error) {
            logForStore(
                loggingService,
                LogLevel.Warning,
                'layoutManagement',
                serviceCall,
                error
            );
            handler(error, null);
        }
    };

export const getAllSharesAction = composeFetchAction(
    'getAllLayoutsWithSharesForOrigin'
);

export const shareLayoutAction = composeFetchAction('shareLayoutWithUser');

export const duplicateLayoutAction = composeFetchAction('duplicateLayout');

export const deleteLayoutAction = composeFetchAction('deleteLayout');

export const createLayoutAction = composeFetchAction('createLayout');
